// extracted by mini-css-extract-plugin
export default {"checkboxItem":"formik-checkbox-group-field-module--checkboxItem--c61b0","label":"formik-checkbox-group-field-module--label--306a1"};